import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { FileWarning } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const fD = (s) => String(s || "").split("-").reverse().join("/");

export const RicetteDaCaricareBox = () => {
  const { selectedStructure } = useAuth();
  const nav = useNavigate();
  const { data: list = [] } = useQuery({
    queryKey: ["ricette-attesa", selectedStructure],
    refetchInterval: 60000,
    queryFn: async () => { try { return (await api.get("/visite-mediche/ricette-attesa", { params: selectedStructure && selectedStructure !== "all" ? { structure_id: selectedStructure } : {} })).data; } catch { return []; } },
  });
  if (!list.length) return null;
  const scadute = list.filter((r) => r.scaduta).length;
  return (
    <div className={`gr-card p-5 border-2 ${scadute ? "border-red-300" : "border-amber-300"}`} data-testid="dash-ricette-attesa">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-head font-bold flex items-center gap-2"><FileWarning size={18} className={scadute ? "text-red-600" : "text-amber-600"} /> Ricette da caricare</h2>
        <span className={`text-xs font-bold rounded-full px-2 py-0.5 ${scadute ? "bg-red-600 text-white" : "bg-amber-100 text-amber-800"}`} data-testid="dash-ricette-attesa-count">{list.length}</span>
      </div>
      <div className="space-y-1.5 max-h-[300px] overflow-y-auto pr-1">
        {list.map((r) => (
          <button key={r.visita_id} type="button" onClick={() => nav(r.evento ? "/infettive" : `/cartella-clinica?ospite=${r.ospite_id}`)} className={`w-full text-left rounded-lg border px-3 py-2 text-sm transition-colors ${r.scaduta ? "bg-red-50 border-red-300 hover:bg-red-100" : "bg-amber-50/60 border-amber-200 hover:bg-amber-50"}`} data-testid={`dash-ricetta-${r.visita_id}`}>
            <div className="flex items-center gap-2"><b className="truncate">{r.ospite}</b><span className={`ml-auto shrink-0 text-[10px] font-bold uppercase rounded-full px-2 py-0.5 ${r.scaduta ? "bg-red-600 text-white" : "bg-white text-amber-800 border border-amber-300"}`}>{r.scaduta ? "Scaduta" : r.giorni === 0 ? "Scade oggi" : `${r.giorni} gg rimasti`}</span></div>
            <div className="text-[11px] text-slate-600">{r.evento ? "Evento sanitario · " : ""}Visita {r.canale === "remoto" ? "da remoto " : ""}del {fD(r.data)}{r.tipo_visita ? ` · ${r.tipo_visita}` : ""}{r.medico ? ` · ${r.medico}` : ""} — entro il {fD(r.scadenza)}</div>
          </button>
        ))}
      </div>
    </div>
  );
};
